import { Injectable } from '@angular/core';
import {
  RegisterMemberPaymentRow,
  RegisterMemberPaymentTableResult,
  RegisterMemberPaymentTotals,
  RegisterMemberPaymentVehicleTypeGroup,
} from '../../models/report/register-member-payment.model';

@Injectable({ providedIn: 'root' })
export class MapperRegisterMemberPaymentService {
  mapTable(res: unknown): RegisterMemberPaymentTableResult {
    const raw = (res ?? {}) as Record<string, unknown>;
    const groups = (raw['groups'] ?? raw['Groups'] ?? []) as unknown[];
    return {
      siteName: String(raw['siteName'] ?? raw['SiteName'] ?? ''),
      siteAddress: String(raw['siteAddress'] ?? raw['SiteAddress'] ?? ''),
      siteTaxId: String(raw['siteTaxId'] ?? raw['SiteTaxId'] ?? ''),
      subscriptionName: String(raw['subscriptionName'] ?? raw['SubscriptionName'] ?? ''),
      vehicleTypeName: String(raw['vehicleTypeName'] ?? raw['VehicleTypeName'] ?? ''),
      startDate: (raw['startDate'] ?? raw['StartDate'] ?? null) as string | null,
      endDate: (raw['endDate'] ?? raw['EndDate'] ?? null) as string | null,
      groups: groups.map((g) => this.mapVehicleGroup(g)),
      totals: this.mapTotals(raw['totals'] ?? raw['Totals'] ?? {}),
    };
  }

  private mapVehicleGroup(dto: unknown): RegisterMemberPaymentVehicleTypeGroup {
    const g = (dto ?? {}) as Record<string, unknown>;
    const rows = (g['rows'] ?? g['Rows'] ?? []) as unknown[];
    return {
      vehicleTypeId: Number(g['vehicleTypeId'] ?? g['VehicleTypeId'] ?? 0),
      vehicleTypeName: String(g['vehicleTypeName'] ?? g['VehicleTypeName'] ?? ''),
      rowCount: Number(g['rowCount'] ?? g['RowCount'] ?? 0),
      sumFee: Number(g['sumFee'] ?? g['SumFee'] ?? 0),
      rows: rows.map((r) => this.mapRow(r)),
    };
  }

  private mapRow(dto: unknown): RegisterMemberPaymentRow {
    const r = (dto ?? {}) as Record<string, unknown>;
    return {
      seq: Number(r['seq'] ?? r['Seq'] ?? 0),
      license: String(r['license'] ?? r['License'] ?? ''),
      feeTypeName: String(r['feeTypeName'] ?? r['FeeTypeName'] ?? ''),
      fee: Number(r['fee'] ?? r['Fee'] ?? 0),
      registerMemberType: String(r['registerMemberType'] ?? r['RegisterMemberType'] ?? ''),
      subscriptionName: String(r['subscriptionName'] ?? r['SubscriptionName'] ?? ''),
      paymentDate: (r['paymentDate'] ?? r['PaymentDate'] ?? null) as string | null,
      memberStart: (r['memberStart'] ?? r['MemberStart'] ?? null) as string | null,
      memberEnd: (r['memberEnd'] ?? r['MemberEnd'] ?? null) as string | null,
      requestNo: String(r['requestNo'] ?? r['RequestNo'] ?? ''),
    };
  }

  private mapTotals(dto: unknown): RegisterMemberPaymentTotals {
    const t = (dto ?? {}) as Record<string, unknown>;
    return {
      rowCount: Number(t['rowCount'] ?? t['RowCount'] ?? 0),
      sumFee: Number(t['sumFee'] ?? t['SumFee'] ?? 0),
    };
  }
}
